export const SET_RESCHEDULE_ON_BEHALF_AGENT_ID =
  'BUS/SET_RESCHEDULE_ON_BEHALF_AGENT_ID';

export default function setRescheduleOnBehalfAgentId(agentId) {
  return {
    type: SET_RESCHEDULE_ON_BEHALF_AGENT_ID,
    agentId,
  };
}
